import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as project from '../project'

// TODO: We may want to make this an enum in the future if we want to have a fixed set of roles that can be filled for an engagement. For now, we'll leave it as a text field to allow for more flexibility.
export const RESOURCE = {
  payload: {
    canBeOptional: true,
    constraints: {
      min: { value: 0 },
    },
    context: core.dms.models.Attribute.Id.Context.from({
      context: project.RESOURCE.payload.dimension.partialId,
      partialId: project.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Status of this project in the proposal pipeline meant to be used for the Employee Planning application. Examples are: Active, Likely, Prospective, and Closed.',
    isOptional: true,
    name: 'Status',
    partialId: PartialId.Standard.create('status'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
